'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isTypeOneOf = isTypeOneOf;

var _isAction = require('./isAction');

function isTypeOneOf(action) {
    for (var _len = arguments.length, factories = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        factories[_key - 1] = arguments[_key];
    }

    return (0, _isAction.isAction)(action) ? factories.some(function (factory) {
        return action.type === factory.type;
    }) : false;
}
//# sourceMappingURL=isTypeOneOf.js.map


// WEBPACK FOOTER //
// ./node_modules/@zaibot/fsa/es5/isTypeOneOf.js